import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinaurangabad() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Aurangabad',
        heading: 'Urbania on rent in pune: Urbania On Rent in Aurangabad',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Urbania On Rent in Aurangabad for corporate groups, families, tourists, and event travelers planning comfortable outstation travel to Aurangabad. Our well‑maintained Force Urbania fleet provides spacious seating, air‑conditioned comfort, and smooth performance, making it ideal for long-distance journeys, airport transfers, corporate outings, weddings, sightseeing, and group trips from Pune to Aurangabad. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania hire in Aurangabad.',

        top: 'Top Places to Visit in Aurangabad with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "Ajanta Caves, a UNESCO World Heritage Site, are a complex of 30 rock-cut Buddhist caves dating from the 2nd century BCE to about 480 CE. Known for their exquisite murals, frescoes, and intricate sculptures, the caves depict the life of Buddha and Jataka tales. Surrounded by lush hills and the Waghora river, Ajanta offers a serene and historically rich experience for art and history enthusiasts."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, another UNESCO World Heritage Site near Aurangabad, comprise 34 rock-cut temples and monasteries representing Buddhist, Hindu, and Jain traditions. The 8th-century Kailasa temple, carved from a single rock, is a marvel of ancient engineering and artistry. Visitors can explore the detailed sculptures, expansive courtyards, and historical significance of this multi-religious heritage site."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Bibi Ka Maqbara, often called the 'Taj of the Deccan,' is a beautiful mausoleum built by Azam Shah in memory of his mother, Dilras Banu Begum. Resembling the Taj Mahal but smaller in scale, it features white marble, elegant domes, and landscaped gardens. The monument reflects Mughal architectural grandeur and is a popular site for photography and historical exploration."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort, originally known as Devagiri, is a 12th-century hilltop fort famous for its formidable defenses, intricate gateways, and strategic location. Visitors can explore its massive ramparts, secret passages, and historic cannons while enjoying panoramic views of the surrounding landscape. The fort stands as a symbol of medieval military architecture in India."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Aurangabad Caves are a group of 12 rock-cut Buddhist shrines located on a hill near the city. Dating back to the 6th and 7th centuries, the caves feature intricate carvings, stupas, and images of Buddhist deities. The serene atmosphere, coupled with scenic views of the city and surrounding hills, makes it an enriching spiritual and historical site for visitors."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki is a 17th-century water mill located in Aurangabad, originally built to grind grains for the nearby seminary and travelers. The mill is powered by a water channel from a mountain spring, showcasing ancient engineering ingenuity. Surrounded by gardens, fountains, and a mosque, Panchakki is a unique blend of history, architecture, and technology."
  },
  {
    "title": "Salim Ali Lake & Bird Sanctuary",
    "description": "Salim Ali Lake and Bird Sanctuary is a peaceful haven for bird watchers and nature enthusiasts. The lake attracts migratory and local birds, creating a vibrant ecosystem. Walking paths, lush greenery, and serene water bodies make it an ideal spot for photography, relaxation, and enjoying the natural beauty within the city limits of Aurangabad."
  },
  {
    "title": "Grishneshwar Temple",
    "description": "Grishneshwar Temple, one of the 12 Jyotirlinga shrines of Lord Shiva, is located near Ellora Caves. The temple, rebuilt in the 18th century, features intricate carvings, traditional Maratha architecture, and a spiritual atmosphere. Pilgrims and tourists visit to offer prayers and admire the temple’s religious significance and artistic craftsmanship."
  },
  {
    "title": "Salim Ali Bird Sanctuary",
    "description": "Situated near Salim Ali Lake, this sanctuary provides a safe habitat for migratory and local birds. Visitors can enjoy peaceful walks, birdwatching, and photography. The greenery and waterbody ecosystem offer a refreshing break from the urban environment, making it a must-visit for nature enthusiasts."
  },
  {
    "title": "Himayat Baugh",
    "description": "Himayat Baugh is a historical garden complex featuring elegant landscaping, fountains, and pathways. Once a royal garden, it offers a tranquil setting to enjoy a leisurely walk amidst flowering plants and shaded areas. Its serene environment makes it a favorite spot for locals and tourists looking to relax and connect with nature in Aurangabad."
  }
],




"services": [
{
"name": "Urbania on Rent in Aurangabad",
"description": "Urbania on Rent in Aurangabad provides reliable and comfortable Urbania bus rentals for local and long-distance travel. Ideal for families, groups, and corporate travelers, offering spacious seating, clean interiors, and experienced drivers for a smooth journey."
},
{
"name": "Aurangabad Urbania Bus Hire",
"description": "Aurangabad Urbania Bus Hire offers flexible rental options for AC and non-AC buses, catering to one-way, round-trip, and multi-day travel plans with punctual service and well-maintained vehicles."
},
{
"name": "Urbania Rental Service Aurangabad",
"description": "Urbania Rental Service Aurangabad provides dependable Urbania buses for sightseeing, pilgrimages, corporate tours, and group travel, focusing on safety, comfort, and reliability."
},
{
"name": "Urbania AC Bus on Rent Aurangabad",
"description": "Urbania AC Bus on Rent Aurangabad delivers fully air-conditioned buses for a comfortable and climate-controlled travel experience, making long journeys relaxing for all passengers."
},
{
"name": "Corporate Urbania Hire Aurangabad",
"description": "Corporate Urbania Hire Aurangabad offers organized transportation for corporate teams, business tours, and official events, ensuring punctuality, comfort, and professional drivers."
},
{
"name": "Urbania for Outstation Aurangabad",
"description": "Urbania for Outstation Aurangabad provides reliable buses for long-distance and interstate travel, focusing on safety, comfort, and timely arrivals."
},
{
"name": "Urbania Airport Transfer Aurangabad",
"description": "Urbania Airport Transfer Aurangabad ensures convenient and timely pick-up and drop services to and from Aurangabad airport with experienced chauffeurs and comfortable buses."
},
{
"name": "Luxury Urbania Aurangabad",
"description": "Luxury Urbania Aurangabad offers premium buses with plush seating, modern interiors, and superior ride comfort, perfect for VIP travel and special occasions."
},
{
"name": "Affordable Urbania Hire Aurangabad",
"description": "Affordable Urbania Hire Aurangabad provides budget-friendly bus rentals without compromising safety or comfort, suitable for groups and cost-conscious travelers."
},
{
"name": "Chauffeur Driven Urbania Aurangabad",
"description": "Chauffeur Driven Urbania Aurangabad ensures a stress-free journey with trained, verified drivers experienced in both local and long-distance routes."
},
{
"name": "Urbania for Wedding Events Aurangabad",
"description": "Urbania for Wedding Events Aurangabad offers well-decorated and comfortable buses for weddings and related events, ensuring safe and stylish transportation for guests."
},
{
"name": "Urbania for Corporate Travel Aurangabad",
"description": "Urbania for Corporate Travel Aurangabad delivers professional transport services for business travel, team outings, and corporate events, emphasizing reliability and comfort."
},
{
"name": "Best Urbania Rental Aurangabad",
"description": "Best Urbania Rental Aurangabad is known for top-rated buses, professional drivers, and excellent customer service, making it a preferred choice for all types of travel."
},
{
"name": "Urbania Group Travel Aurangabad",
"description": "Urbania Group Travel Aurangabad provides spacious and coordinated transportation for large groups, ensuring everyone travels together safely and comfortably."
},
{
"name": "Reliable Urbania Hire Aurangabad",
"description": "Reliable Urbania Hire Aurangabad offers dependable bus rentals with a focus on punctuality, comfort, safety, and excellent customer support."
}
],
"tableData": [
["Urbania on Rent in Aurangabad", "Aurangabad Urbania Bus Hire"],
["Urbania Rental Service Aurangabad", "Urbania AC Bus on Rent Aurangabad"],
["Corporate Urbania Hire Aurangabad", "Urbania for Outstation Aurangabad"],
["Urbania Airport Transfer Aurangabad", "Luxury Urbania Aurangabad"],
["Affordable Urbania Hire Aurangabad", "Chauffeur Driven Urbania Aurangabad"],
["Urbania for Wedding Events Aurangabad", "Urbania for Corporate Travel Aurangabad"],
["Best Urbania Rental Aurangabad", "Urbania Group Travel Aurangabad"],
["Reliable Urbania Hire Aurangabad", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Urbania On Rent in Aurangabad for Comfortable Travel",
        "WhyChoosedescription": "Urbania On Rent in Aurangabad is ideal for sightseeing, family trips, group tours, corporate travel, and leisure journeys, ensuring a hassle-free and comfortable ride."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses in Aurangabad are equipped with air-conditioning, reclining seats, ample legroom, and sufficient luggage space for a smooth journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "All drivers are trained, licensed, and experienced in Aurangabad city routes and nearby destinations, ensuring safe and stress-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Urbania On Rent in Aurangabad offers competitive pricing with no hidden charges, making group and tourist travel cost-effective."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for sightseeing, family outings, corporate trips, multi-day journeys, and customized travel plans."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and well-maintained to ensure passenger comfort and hygiene."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Urbania On Rent in Aurangabad service guarantees on-time pickups, reliable travel support, and a smooth journey."
    }
]
}
const faqData = [
    {
        question: 'Can Urbania On Rent in Aurangabad be booked for sightseeing and group travel?',
        answer: 'Yes, it is perfect for local sightseeing, family trips, group tours, and corporate travel.'
    },
    {
        question: 'How can I book Urbania On Rent in Aurangabad?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Urbania On Rent in Aurangabad?',
        answer: 'This service offers spacious seating, professional drivers, clean vehicles, flexible travel plans, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced with Aurangabad routes?',
        answer: 'Yes, all drivers are licensed, trained, and familiar with Aurangabad city routes and nearby destinations.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Aurangabad and nearby areas.'
    },
    {
        question: 'Is Urbania On Rent in Aurangabad available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey.'
    },
    {
        question: 'Is this service suitable for families and corporate groups?',
        answer: 'Yes, Urbania On Rent in Aurangabad is ideal for families, corporate groups, and large travel parties.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sameer Khan',
        feedback: 'We rented an Urbania bus in Aurangabad for a group tour. The journey was very comfortable and the bus was clean and spacious.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Nisha Kulkarni',
        feedback: 'Excellent service and professional driver. Urbania On Rent in Aurangabad made our sightseeing trip smooth and enjoyable.',
        rating: 5
    }
];













































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Aurangabad",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-aurangabad.jpg",
  "description": "Urbania On Rent in Aurangabad offers AC Urbania buses for one-way or round-trip travel, corporate trips, airport transfers, weddings, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation in and around Aurangabad.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-in-aurangabad"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent in Aurangabad | AC Urbania Bus for Tours & Travel 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent in Aurangabad for one-way or round-trip travel, corporate trips, airport transfers, weddings, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation in and around Aurangabad."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Aurangabad, Aurangabad Urbania Bus Hire, Urbania Rental Service Aurangabad, Urbania AC Bus on Rent Aurangabad, Corporate Urbania Hire Aurangabad, Urbania for Outstation Aurangabad, Urbania Airport Transfer Aurangabad, Luxury Urbania Aurangabad, Affordable Urbania Hire Aurangabad, Chauffeur Driven Urbania Aurangabad, Urbania for Wedding Events Aurangabad, Urbania for Corporate Travel Aurangabad, Best Urbania Rental Aurangabad, Urbania Group Travel Aurangabad, Reliable Urbania Hire Aurangabad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/108.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinaurangabad;